import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FALLBACK_URLS } from "../../utils/constants";
import { fetchContentOrConfig } from "../APIServices/GlobalService";
import { RootState } from "../store";
export interface IglobalState {
  _uuid: string;
  loading: boolean;
  id: string;
  role: string;
  carrierId: string;
  contentOrConfigData: any;
  redirectUrl: string;
  managedEquipment: boolean;
  mode: string;
  addionalInfo: string;
  scdmResponse: string;
}

const initialState: IglobalState = {
  _uuid: "",
  id: "",
  loading: false,
  role: "",
  carrierId: "",
  contentOrConfigData: null,
  redirectUrl: FALLBACK_URLS.DEFAULT_REDIRECT_URL,
  managedEquipment: true,
  mode: "",
  addionalInfo: "",
  scdmResponse: ""
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    activateLoading: (state) => {
      state.loading = true;
    },
    deactivateLoading: (state) => {
      state.loading = false;
    },
    changeUUID: (state, actions) => {
      state._uuid = actions?.payload;
    },
    changeId: (state, actions) => {
      state.id = actions?.payload;
    },
    changeManagedEquipment: (state, actions) => {
      state.managedEquipment = actions?.payload;
    },
    changeRole: (state, actions) => {
      state.role = actions?.payload;
    },
    changeCarrierId: (state, actions) => {
      state.carrierId = actions?.payload;
    },
    changeSCDMResponse: (state, actions) => {
      state.scdmResponse = actions?.payload;
    },
    changeRedirectUrl: (state, actions) => {
      state.redirectUrl = actions?.payload;
    },
    changeMode: (state, actions) => {
      state.mode = actions?.payload;
    },
    changeAddionalInfo: (state, actions) => {
      state.mode = actions?.payload;
    },
    clearBannerInfo: (state) => {
     
      let temp = [...state.contentOrConfigData];
     // console.log("temp",temp,state)
      temp = temp?.filter((item: any) => item?.content === null || (item?.content?.length > 0 && item?.content[0]?.contentTypeName != "fpw_alert_banner"))
      state.contentOrConfigData = temp;
      
    }
  },
  extraReducers: (builder) => {
    builder.addCase(storeContentOrConfig.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(storeContentOrConfig.fulfilled, (state, action) => {
      if (action?.payload) {
        state.contentOrConfigData = action?.payload;
      }
      state.loading = false;
    });
    builder.addCase(storeBannerData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(storeBannerData.fulfilled, (state, action) => {
      if (action?.payload) {
        state.contentOrConfigData = action?.payload;
      }
      state.loading = false;
    });
  },
});

export const allcontentOrConfigData = (state: RootState) =>
  state?.global?.contentOrConfigData;

export const {
  activateLoading,
  deactivateLoading,
  changeId,
  changeRole,
  changeUUID,
  changeCarrierId,
  changeRedirectUrl,
  changeManagedEquipment,
  changeMode,
  changeAddionalInfo,
  clearBannerInfo,
  changeSCDMResponse,
} = globalSlice.actions;
export default globalSlice.reducer;

export const storeContentOrConfig = createAsyncThunk(
  "Global/storeContentOrConfig",
  async () => {
    const response: any = await fetchContentOrConfig();
    return response;
  }
);
export const storeBannerData = createAsyncThunk(
  "Global/storeBannerData",
  async (payload: any) => {
    const response: any = await fetchContentOrConfig({ ...payload });
    return response;
  }
);
